import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import {
  AttachmentRowContainer,
  AttachmentItemContainer,
} from './UserRequestsStyles';
import ErrorIcon from '@material-ui/icons/Error';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Attachment } from './types';

type AttachmentsListProps = {
  items: Attachment[];
};

const AttachmentError = () => (
  <AttachmentItemContainer>
    <ErrorIcon color="error" />
    <Box>
      <Typography style={{ marginBottom: 8 }} variant="body1">
        Error:
      </Typography>
      <Typography variant="caption">This file can't been loaded</Typography>
    </Box>
  </AttachmentItemContainer>
);

const AttachmentCard: React.FC<{
  name: string;
  meta?: string;
  actions?: React.ReactNode;
}> = ({ name, meta, actions }) => (
  <AttachmentItemContainer style={{ justifyContent: 'space-between' }}>
    <Box>
      <Typography style={{ marginBottom: 8 }} variant="body1">
        {name}
      </Typography>
      {meta ? (
        <Typography style={{ color: '#092241B2' }} variant="caption">
          {meta}
        </Typography>
      ) : null}
    </Box>
    {actions}
  </AttachmentItemContainer>
);

const AttachmentRow: React.FC<{ att: Attachment }> = ({ att }) => {
  const isError = !!att.error;
  const downloadLink = att.downloadUrl || att.url;
  const meta =
    !isError && att.uploadedBy && att.uploadedAt
      ? `by ${att.uploadedBy} on ${att.uploadedAt}`
      : undefined;

  const handleDownload = () => {
    if (!downloadLink) return;
    window.location.assign(downloadLink);
  };

  return (
    <AttachmentRowContainer>
      {isError ? (
        <AttachmentError />
      ) : (
        <AttachmentCard
          name={att.name}
          meta={meta}
          actions={
            <IconButton size="small" onClick={handleDownload}>
              <GetAppIcon />
            </IconButton>
          }
        />
      )}
    </AttachmentRowContainer>
  );
};

const AttachmentsList: React.FC<AttachmentsListProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return <Typography variant="body2">No attachments</Typography>;
  }

  return (
    <Box>
      {items.map(att => (
        <AttachmentRow key={att.id} att={att} />
      ))}
    </Box>
  );
};

export default AttachmentsList;
